import { NavLink } from "react-router-dom";

const TABS = [
  { path: "settings", label: "Settings" },
  { path: "params", label: "Parameters" },
  { path: "designer", label: "Designer" },
  { path: "endpoint", label: "Data source" },
  { path: "mapping", label: "Field mapping" },
];

export function ReportTabs({ reportId, title }: { reportId: string; title: string }) {
  return (
    <div className="page-header" style={{ flexDirection: "column", alignItems: "stretch" }}>
      <h1>{title}</h1>
      <div className="tabs">
        {TABS.map((tab) => (
          <NavLink
            key={tab.path}
            to={`/reports/${reportId}/${tab.path}`}
            className={({ isActive }) => (isActive ? "tab-button active" : "tab-button")}
          >
            {tab.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
